import React from "react";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import "swiper/swiper.scss";
import "swiper/modules/navigation/navigation.scss";
import "swiper/modules/pagination/pagination.scss";
import "swiper/modules/scrollbar/scrollbar.scss";
import "simplebar/dist/simplebar.min.css";
import { SwiperOptions } from "swiper/types/swiper-options";
import useBreakPoints from "hooks/useBreakPoints";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import "./style.scss";

interface Props<T> {
  list: T[];
  itemPrinter: (item: T) => JSX.Element;
}

export default function LandingSlider<T>({ list, itemPrinter }: Props<T>) {
  const { desktopUp } = useBreakPoints();
  const classNameNavigation: string[] = [];
  if (!list || (!!list && list.length < (desktopUp ? 3 : 2))) {
    classNameNavigation.push("__hidden");
  }

  const swiperOptions: SwiperOptions = {
    spaceBetween: 30,
    loopFillGroupWithBlank: false,
    modules: [Navigation, Pagination],
    pagination: {
      el: ".landing-slider__pagination",
      bulletActiveClass: "__active",
      type: "bullets",
      clickable: true,
    },
    navigation: {
      nextEl: ".landing-slider__button.__next",
      prevEl: ".landing-slider__button.__prev",
      disabledClass: "__disabled-custom",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      1000: {
        slidesPerView: 2,
      },
    },
  };

  const cls = ["landing-slider"];

  return (
    <div className={cls.join(" ")}>
      <Swiper style={{ maxHeight: "100%" }} {...swiperOptions}>
        {list.map((item, i) => (
          <SwiperSlide className="landing-slider__slide" key={i}>
            {itemPrinter(item)}
          </SwiperSlide>
        ))}
        <div className="landing-slider__controls d-center mt-8">
          <div className="landing-slider__pagination d-center" />
          <div className={["landing-slider__navigation ", classNameNavigation].join(" ")}>
            <BaseButton className="landing-slider__button __prev">
              <BaseIcon className="landing-slider__button-icon __prev">back</BaseIcon>
            </BaseButton>
            <BaseButton className="landing-slider__button __next">
              <BaseIcon className="landing-slider__button-icon __next">back</BaseIcon>
            </BaseButton>
          </div>
        </div>
      </Swiper>
    </div>
  );
}
